import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import Dialog from "@limitless/modern/feedback/dialog/Dialog";
const MessageDuplicateDialogueDialog = ({
  onSendClick,
  onCancelClick
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    onClose: () => onCancelClick(false),
    id: "dupeDialogueOk",
    title: "Duplicate Dialogue Detected",
    onCancelClick: () => onCancelClick(false),
    onOkClick: onSendClick,
    okDisabled: false,
    okText: "Confirm",
    cancelVariant: "text",
    paperStyle: {
      maxWidth: "400px"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    pb: 2,
    color: "textPrimary",
    variant: "body2"
  }, t("Are you sure you want to post the same dialogue twice?")));
};
export default MessageDuplicateDialogueDialog;
MessageDuplicateDialogueDialog.propTypes = {
  onSendClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired
};